import classnames from 'classnames';

import { ReactComponent as ArrowRight } from '~/assets/images/iconsLibrary/arrow-right.svg';

import styles from './HintTile.module.scss';

export type THintTile = {
  img: string;
  headline: string;
  subheadline: string;
  highlight?: boolean;
};

export default function HintTile({
  img,
  highlight,
  headline,
  subheadline,
}: THintTile): JSX.Element {
  return (
    <div className={classnames(styles.HintTile, highlight && styles.highlight)}>
      <div className={styles.icon}>
        <img
          className={styles.image}
          alt=""
          src={img}
        />
      </div>
      <div>
        <div className={styles.header}>{headline}</div>
        <div className={styles.description}>{subheadline}</div>
      </div>
      <ArrowRight className={styles.arrow} />
    </div>
  );
}
